import { useState } from 'react';
import styled from 'styled-components';
import {
  Breadcrumbs,
  Flex,
  FlexColumn,
  FloatingActionsMenu,
  LineageGraph,
} from '@elementary/common-ui/components';
import { useBreadcrumbs } from '@elementary/common-ui/hooks/useBreadcrumbs';
import type { DagDepthBoundary } from '@elementary/common-ui/components/lineageGraph/types';
import LineageFilters from './components/LineageFilters';

// Leaves room on the right for the graph controls panel.
const TopOverlay = styled(FlexColumn)`
  position: absolute;
  top: 24px;
  left: 24px;
  margin-right: 100px;
  align-items: flex-start;
  gap: 12px;
  z-index: 1;
  pointer-events: none;

  & > * {
    pointer-events: auto;
  }
`;

const BreadcrumbsContainer = styled(Flex)`
  background: ${({ theme }) => theme.palette.common.white};
  border: ${({ theme }) => `1px solid ${theme.palette.common.gray13}`};
  border-radius: 8px;
  padding: 8px;
  padding-right: 14px;
`;

const LineagePage = () => {
  const breadcrumbs = useBreadcrumbs({
    pageTitle: 'Lineage',
  });

  const [dagDepthBoundary, setDagDepthBoundary] = useState<DagDepthBoundary>();

  return (
    <FlexColumn
      sx={{
        width: '100%',
        height: '100%',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <TopOverlay>
        <BreadcrumbsContainer>
          <Breadcrumbs items={breadcrumbs} />
        </BreadcrumbsContainer>
        <LineageFilters dagDepthBoundary={dagDepthBoundary} />
      </TopOverlay>

      <LineageGraph onDagDepthBoundaryChange={setDagDepthBoundary} />
      <FloatingActionsMenu />
    </FlexColumn>
  );
};

export default LineagePage;
